import React, { useEffect, useState } from 'react'

// import { 
//   functions, 
//   //analytics 
// } from '../../firebase'

import SupportPage from '@components/Pages/SupportPage'

export default function SupportLogged(){

    const [ supportType, setSupportType ] = useState('')
    const [ supportQuestion, setSupportQuestion ] = useState('')
    const [ snack, setSnack ] = useState(false)
    const [ error, setError] = useState(false)
    const [ loading, setLoading ] = useState('')
    const [ msgType, setMsgType ] = useState('info')
    const [ alertMsg, setAlertMsg ] = useState('')

    const handleSupportType = event => setSupportType(event.target.value)
    const handleSupportQuestion = event => setSupportQuestion(event.target.value)
    const handleClose = () => setSnack(false)
    const handleError = () => setError(true)

    const showSnack = (type, message) => {
      setLoading(false)
      setSnack(true)
      setMsgType(type)
      setAlertMsg(message)
    }

    const submitSupport = () => {
      setLoading(true)
      // const addSupportMessage = functions.httpsCallable('supportMessageLogged')
      // addSupportMessage({
      //   supportType, 
      //   supportQuestion, 
      // })
      // .then(resp => {
      //   showSnack('success', resp.data)
      // }).catch((error) => {
      //   showSnack('error', 'Error adding support question.')
      // })
    }

    useEffect(() => {
      speechSynthesis.cancel()
    });

    const supportTypes = ['Technical','Other']

    return(
      <main sx={{flexGrow: 1}}>
        <SupportPage 
          submitSupport={submitSupport} 
          supportType={supportType}
          supportQuestion={supportQuestion}
          handleSupportType={handleSupportType}
          handleSupportQuestion={handleSupportQuestion}
          supportTypes={supportTypes}
          showSnack={showSnack}
          snack={snack}
          error={error}
          loading={loading}
          alertMsg={alertMsg}
          msgType={msgType}
          handleClose={handleClose}
          handleError={handleError}
        />
      </main>
    )
}